<template lang="pug">
  .row.product-details
    .col-md-12
      .panel.panel-default(v-if="product")
        .panel-heading
          h3.panel-title Product General Info
        .panel-body
          .row
            label.col-sm-2 Product Name
            .col-sm-4 {{product.name}}
            label.col-sm-2 Alias
            .col-sm-4 {{product.alias}}
          .row
            label.col-sm-2 GTIN
            .col-sm-4 {{product.gtin}}
            label.col-sm-2 Product ID
            .col-sm-4 {{product.customerProductReference}}
          .row
            label.col-sm-2 Package type
            .col-sm-4
              span(v-if="packageType") {{ packageType.name }}
              em.text-muted(v-else) {{ packageErrorMsg }}
            label.col-sm-2 Validation response group
            .col-sm-4 {{product.atiGroupName}}
          .row
            label.col-sm-2 Entry channels
            .col-sm-4(v-if="product.entryChannelSummaryList")
              p(v-for="e in product.entryChannelSummaryList")
                i.fa(:class="{'fa-globe': e['@type'] === 'WEB', 'fa-phone': e['@type'] === 'SMS'}")
                span.pl10 {{ e.name }}
</template>

<script>
import Masterdata from '@/service/apis/Masterdata'

export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      packageType: null,
      packageErrorMsg: null
    }
  },
  watch: {
    product() {
      if (this.product && this.product.packageTypeId) {
        Masterdata.readPackageType(this.product.packageTypeId)
          .then((resp) => {
            this.packageType = resp.data
          })
          .catch((e) => {
            this.packageErrorMsg = e.response.data.message
          })
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/pages/core/configuration/product/ProductDetails.vue